import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { actions as sagaActions, GET_SUBSCRIPTIONS } from './types';
import { actions as loaderReduxActions } from '../../../partials/loader/reducers';
import { actions as reduxActions } from '../reducers';
import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';
import { isArray, isDefined } from '../../../utils/isDefined';
import mapSubscriptions from './mapSubscriptions';
import createProductOptions from '../../../utils/createProductOptions';
import { altGetFullTableData } from '../../../utils/getFullTableData';

export function fetchSubscriptions({ selectedAccount, clientId }) {
  return {
    type: sagaActions[GET_SUBSCRIPTIONS],
    selectedAccount,
    clientId
  };
}

export function* getSubscriptions({ selectedAccount, clientId }) {
  yield put(loaderReduxActions.startSpinLoader());
  let subscriptions = [];
  let data = [];

  if (isDefined(selectedAccount?.externalReference)) {
    try {
      data = yield call(
        altGetFullTableData,
        `${URLS.QUOTE_CLIENTS}/${clientId}/subscription_agreements`,
        {
          account_reference: selectedAccount.externalReference
        }
      );
      subscriptions = isArray(data) ? data : [];
    } catch {}
  } else {
    try {
      data = yield call(
        getData,
        `${URLS.QUOTE_CLIENTS}/${clientId}/subscriptions`
      );
      subscriptions = isArray(data) ? data : [];
    } catch {}
  }

  const { mappedSubscriptions, mappedWithAllStatuses } = yield call(
    mapSubscriptions,
    subscriptions
  );

  const productOptions = yield call(createProductOptions, mappedSubscriptions);

  if (selectedAccount?.type === 'CUSTOMER') {
    yield put(
      reduxActions.updateFilters({
        key: 'account',
        value: [{ ...selectedAccount, label: selectedAccount.filterLabel }]
      })
    );
  }

  yield put(
    reduxActions.setSubscriptions(mappedWithAllStatuses, productOptions)
  );
  yield put(loaderReduxActions.stopSpinLoader());
}

function* watchGetSubscriptions() {
  yield takeLatest(sagaActions[GET_SUBSCRIPTIONS], getSubscriptions);
}

export default watchGetSubscriptions();
